import Constants from '../utils/Constants';

export const en: Locale.Keys = {
  lang: Constants.lang.en,
  menu: {
    ourStory: 'OUR STORY',
    roomsSuites: 'ROOMS & SUITES',
    stayingCora: 'STAYING AT CORA',
    coraCaffe: 'CORA CAFFE',
    spa: 'WELLNESS & SPA',
    meetingsEvents: 'MEETINGS & EVENTS - Busy Cora',
    offers: 'SPECIAL OFFERS',
    gallery: 'GALLERY',
    contactUs: 'CONTACT US',
    bookNow: 'BOOK NOW',
  },
  about: {
    title: 'A warm welcome, from the moment you arrive',
    p1: 'Cora, an intimate hotel with 34 rooms, is a sophisticated combination of comfort and urban dynamism. Settled in a quiet neighborhood yet minutes of driving from the city center, Cora is close to everything you want to see and experience in the ancient city of Split.',
    p2: 'Originating in 1973, the hotel building has gone through thorough property modernization and offers an impressively sleek, warm and welcoming atmosphere. With the aim of creating a bespoke residential feel that takes the guest experience to the next level, personalized service and guest satisfaction are top priorities for our staff.',
  },
  services: {
    title: 'FACILITIES AND SERVICE',
    frontDesk: '24/7 FRONT DESK',
    breakfast: 'SUMPTOUS BREAKFAST',
    rooftop: 'ROOFTOP BAR',
    spa: 'WELLNESS & SPA',
    gym: 'GYM',
    conference: 'CONFERENCE VENUE',
    wheelchair: 'WHEELCHAIR ACCESS',
    pet: 'PET FRIENDLY',
    parking: 'PARKING',
    eCharging: 'E-CHARGING',
  },
  roomsAndSuites: {
    title: 'ROOMS AND SUITES',
    subtitle: 'YOUR PRIVATE PLACE OF LUXURY',
    p1: 'Each room and suite offers a refined, residentially styled atmosphere completed with the latest technology, comfortable furnishings and exquisite attention to detail.',
    comfortTitle: 'Comfort',
    comfort: 'Comfort Room',
    superiorCourtyardTitle: 'Superiror I',
    superiorCourtyard: 'Superiror Courtyard View Room',
    superiorStreetTitle: 'Superior II',
    superiorStreet: 'Superior Street View Room',
    suiteTitle: 'Suites',
    suite: 'Junior Suite',
    showMore: 'SHOW MORE',
  },
  comfortRoom: {
    title: 'COMFORT ROOM',
    subtitle: 'comfort',
    p1: 'Tastefully furnished with intimate, elegant feel, rooms at Cora create a stylish base from which to explore the vibrant neighborhood.',
  },
  superiorCourtyard: {
    title: 'SUPERIOR COURTYARD VIEW ROOM',
    subtitle: 'superior I',
    p1: 'Tastefully furnished with intimate, elegant feel, rooms at Cora create a stylish base from which to explore the vibrant neighborhood.',
  },
  superiorStreet: {
    title: 'SUPERIOR STREET VIEW ROOM',
    subtitle: 'superior II',
    p1: 'Tastefully furnished with intimate, elegant feel, rooms at Cora create a stylish base from which to explore the vibrant neighborhood.',
  },
  juniorSuite: {
    title: 'JUNIOR SUITE',
    subtitle: 'suites',
    p1: 'Soft colors and thoughtful details conspire to create the look and feel of this bright, serene space of modern luxury.',
  },
  stayingAtCora: {
    title: 'STAYING AT CORA',
    restaurantTitle: 'DELICIOUS CORA',
    restaurant:
      "...make yourself comfortable in the Delicious Cora, a contemporary restaurant with an elegantly appointed interior showcasing our chef's culinary vision inspired by the rich variety of Mediterranean fresh, local produce.\n\nBREAKFAST\nfrom 06:30 until 10:30 h\n\nAuthenticity and exquisite flavors are the main features of the signature regional dishes served at our sumptuous breakfast, along with a buffet of international favorites.",
    spaTitle: 'WELLNESS & SPA',
    spa: '...the hotel spa is a serene escape with treatment rooms, a hot tub, sauna, and a small gym. It`s a dedicated space for guests to unwind and rejuvenate within the heart of the hotel.',
    conferenceTitle: 'CONFERENCE VENUE',
    conference:
      '...perfect for smaller to medium-sized meetings or chic private gatherings, the conference venue offers setting and service that ensures every occasion is unforgettable.',
    rooftopTitle: 'CORA CAFFE',
    rooftop:
      '...the rooftop bar, which can be reached via panoramic elevator, is one of the star features of the hotel, offering beverages, handcrafted drinks and views that extend to the mountains on one side and the city skyline on the other.',
  },
  coraCaffe: {
    title: 'CORA CAFFE ROOFTOP BAR',
    subtitle: 'CORA CAFFE',
    p1: 'The rooftop bar, which can be reached via panoramic elevator, is one of the star features of the hotel, offering beverages, handcrafted drinks and views that extend to the mountains on one side and the city skyline on the other.',
    ul1: 'Summer working hours: ',
    li1: 'Monday - Sunday',
    p2: 'Free parking - 2 hours for guests of Cora Caffe Rooftop Bar',
    p3: 'Cora Caffe Menu',
    offHoursMessage: {
      header: 'Dear guests,',
      p1: 'During the winter season, the Cora Caffe rooftop bar is temporarily closed.',
      p2: 'We will be happy to host you in our bar on the ground floor of the Cora Hotel.',
      footer: 'Cora team',
    },
  },
  spa: {
    title: 'Relaxe and revive',
    subtitle: 'WELLNESS & SPA',
    button: 'VIEW MENU',
    p1: 'Indulge in our relaxing spa treatments and rejuvenate your mind, body and soul.',
    p2: `A WRITTEN COMPLAINT CAN BE MADE AT THE RECEPTION DESK OF CORA HOTEL, BY MAIL ADDRESSED TO PUT SUPAVLA 39, 21000 SPLIT, CROATIA OR VIA E-MAIL info@cora-hotel.com CONTACT +3821293100`,
    p3: 'THE PRICES ARE EXPRESSED IN EUR, VAT IS INCLUDED IN PRICE.',
    massage: {
      title: 'Massages',
      body: {
        title: 'Hot Stone Massage with White Jade',
        subtitle:
          'Hot stone massage with white Jade incorporates the benefits of both heated stones an the unique properties of jade. White jade is often associated with promoting balance and harmony.',
      },
      muscle: {
        title: 'Intensive Muscle Release',
        subtitle:
          'These services are designed to promote overall wellness and reduce stress, tension and muscle pain.',
      },
      cora: {
        title: 'Mediterranean Relax Massage',
        subtitle:
          'Relax massage provides relaxation and balance in thebody and mind.',
      },
      additional: {
        title: 'Additional service in massage',
        l1: 'Face massage',
        l2: 'Feet massage',
        l3: 'Scalpt massage',
      },
    },
    bodyritual: {
      title: 'BODY RITUAL',
      mediterranean: {
        title: 'Mediterranean Ritual',
        subtitle:
          'Retreat yourself with scrub and unique technique massage relaxing,just like the Mediterranean lifestyle.',
      },
      detox: {
        title: 'Detox Ritual',
        subtitle:
          'Cleanse and purify your body with a detoxifying treatment. Special mud or clay, sea salt, and vitamins draw out toxins and rebalance your skin. All of this followed with a full body massage.',
      },
      scrub: {
        title: 'Body Scrub',
        subtitle:
          'The scrub will gently slough away dead skin cells, encouraging the regeneration of new cells and perfectly prepping the skin.',
      },
    },
    facial: {
      title: 'FACIAL',
      retreat: {
        title: 'Retreat Facial with Ultrasonic Spatula',
        subtitle:
          'A Cora luxury facial is a unique pampering treatment for the face that typically involves a series of steps designed to deeply cleanse and exfoliate the skin with an ultrasonic spatula. Also, hydrates and rejuvenates the skin with a lifting effect and boosts the skin.',
      },
      exceptional: {
        title: 'Exceptional Facial',
        subtitle: `Marine "lifting" treatment that redefines facial contours and restores the skin's density thanks to the combination of the patented marine replenishment complex and the exclusive Energilift massage technique.`,
      },
      silicium: {
        title: 'Silicium Facial',
        subtitle:
          'This anti-aging treatment is inspired by face fitness and combines an exclusive massage technique with a professional cryo-firming double mask to firm the skin, fill in wrinkles, and freshen the complexion in just 60 minutes.',
      },
      hyalu: {
        title: 'Hyalu-procollagene Facial',
        subtitle:
          'Wrinkle-to-wrinkle treatment combining hyaluronic acids and marine pro-collagen with Roller Booster. Instantly, the face looks younger, as if relaxed, and even established wrinkles appear smoothed.',
      },
      energizing: {
        title: 'Energizing Facial',
        subtitle:
          'The marine shot for urban skin! Detoxifying treatment to refresh the features, and recover a fresh complexion and smooth skin.',
      },
      hydra: {
        title: 'Hydra Facial',
        subtitle: `Thalgo's signature marine-inspired facial concentrates the ocean's benefits to help restore perfect skin quality, delivering intense and lasting hydration.`,
      },
      beauty: {
        title: 'The Joy of Beauty',
        subtitle:
          'These treatments are great for all skin types and will reveal a healthier, more radiant complexion of the skin.',
      },
      additional: {
        title: 'Additional Service in Facial',
        l1: 'Scalpt massage',
        l2: 'Ultrasonic Spatula',
      },
    },
    wax: {
      title: 'Wax',
      face: {
        title: 'Face & brows',
        l1: 'Lip',
        l2: 'Chin',
        l3: 'Brows shaping',
        l4: 'Brows colour',
      },
      bikini: {
        title: 'Bikini',
        l2: 'Bikini',
        l1: 'Brazilian',
      },
      body: {
        title: 'Body',
        l1: 'Underarm',
        l2: 'Half arm',
        l3: 'Half leg',
        l4: 'Full arm',
        l5: 'Full leg',
        l6: 'Back or chest',
      },
    },
    treatments: {
      title: 'Hand & feet care',
      pedicure: {
        title: 'Manicure / Pedicure',
        l1: 'Manicure',
        l2: 'Spa manicure',
        l3: 'Pedicure',
        l4: 'Spa pedicure',
      },
      additional: {
        title: 'Additional Service',
        l1: 'CND Shellac',
        l2: 'Soak-off Removal',
        l3: 'Nail polish',
        l4: 'Gel/Dipping/Acryl Removal',
      },
    },
  },
  gallery: {
    title: 'GALLERY',
  },
  amenities: {
    entertainment: {
      title: 'ENTERTAINMENT',
      tv: 'Smart TV with Cable/Satellite channels',
    },
    bedFeatures: {
      title: 'BED FEATURES',
      sheets: 'High-class collection bed sheets',
      pillow: 'Hypoallergenic pillow',
      pillowMenu: 'Pillow menu',
      service: 'Turndown service',
    },
    bath: {
      title: 'BATHROOM',
      shower: 'Bathroom with walk-in shower',
      hairdryer: 'Hairdryer',
      cosmetic: 'Cosmetic assortment',
      scale: 'Weight scale',
      amenities: 'Long-stay amenities (per request)',
      heating: 'Bathroom floor heating',
    },
    office: {
      title: 'OFFICE/TELECOM',
      telephone: 'Telephone',
      wifi: 'Complimentary wireless high-speed internet access',
      wakeUp: 'Wake-up service (per request)',
      elePlug: 'Universal electric plug (per request)',
    },
    dining: {
      title: 'DINING',
      wine: 'Welcome bottle of wine',
      minibar: 'Refrigerated minibar',
      kettle: 'Kettle (tea, coffee)',
    },
    features: {
      title: 'ROOM FEATURES',
      smoke: 'Non-smoking',
      ac: 'Air-conditioning',
      desk: 'Writing desk',
      light: 'Reading light',
      safe: 'In-room electronic safe (accommodates laptop)',
      bathrobe: 'Bathrobes & slippers',
      laundry: 'Laundry bag',
    },
    additional: {
      title: 'ADDITIONAL SERVICES',
      beach: 'Beach accessories (per request)',
      crib: 'Crib (per request)',
      gifts: 'Welcome gifts for children (info available at Front Desk)',
      pets: 'Services for pets (per request)',
    },
  },
  impressum: {
    country: 'Croatia',
    propName: 'Property name',
    propAddress: 'Property address',
    compName: 'Company name',
    compAddress: 'Company address',
    vat: 'Vat',
    commercialCourt: {
      title: 'Commercial court',
      p1: 'The company is signed into a court register at Commercial court in Split under the number 060086339.',
    },
    phone: 'Phone',
  },
  privacyPolicy: {
    title: 'Privacy Policy – Cora Hotel',
    introduction: {
      title: 'Introduction and Data Controller Information',
      text: 'This Statement on Personal Data Protection applies to MANAS d.o.o., 21000 Split, Barakovićeva 18, OIB: 77290534017, VAT ID: HR77290534017 (hereinafter: Cora Hotel). Cora Hotel, 21000 Split, Put Supavla 39, will handle your personal data in accordance with General Regulation (EU) 2016/679 on the protection of individuals with regard to the processing of personal data and the free movement of such data (General Data Protection Regulation), and the Law on Implementation of the General Data Protection Regulation (Narodne novine No. 42/2018). All data is protected with appropriate technical and organizational security measures against unauthorized access, misuse, loss, or destruction.',
    },
    sections: [
      {
        title: '1. General Information and Response Deadlines',
        blocks: [
          {
            type: 'paragraph',
            text: 'This statement outlines in a clear and concise manner how we collect, process, and use your data, as well as your rights.',
          },
          {
            type: 'list',
            items: [
              { text: 'Data Controller: Cora Hotel (MANAS d.o.o.)' },
              { text: 'E-mail Contact: voditelj.obrade@manas.hr' },
              { text: 'Phone: +385 (0) 21 644 200' },
              {
                text: 'Data Protection Officer (DPO): voditelj.obrade@manas.hr',
              },
            ],
          },
          {
            type: 'paragraph',
            text: 'The Data Controller shall provide information on action taken on a request to the data subject without undue delay and at the latest within one month of receipt of the request. This period may be extended by two further months where necessary, taking into account the complexity and number of the requests, of which the data subject shall be informed. All disputes shall be resolved before the competent court in Split.',
          },
        ],
      },
      {
        title: '2. Types of Personal Data We Process',
        blocks: [
          {
            type: 'paragraph',
            text: 'For the sake of clarity and transparency, Cora Hotel collects and processes only the personal data necessary for business operations, communication, and provision of hospitality services:',
          },
          {
            type: 'list',
            items: [
              {
                text: 'Website Contact Forms & Inquiries: Name, surname, e-mail address, and phone number.',
              },
              {
                text: 'Accommodation Bookings & Guest Registration: Name, surname, residential address, e-mail address, phone number, and all mandatory data required for the fulfillment of the hospitality contract and official legal registration in the national eVisitor system. (Note: We do not collect ID data or private residential addresses of authorized corporate representatives or owners).',
              },
              {
                text: 'Business Cooperation: Name, surname, business e-mail, phone number, and professional position of employees or authorized persons of our business partners and suppliers.',
              },
              {
                text: 'Subsequent Payment: Credit card details for products or services that a guest did not declare or pay for upon departure.',
              },
            ],
          },
        ],
      },
      {
        title: '3. Health and Wellness Treatment Data',
        blocks: [
          {
            type: 'paragraph',
            text: 'Processing of personal data concerning your health condition, collected for the purpose of providing adequate wellness treatment in relation to the health condition, preventing potential injuries, and ensuring user safety, is carried out strictly based on your explicit consent pursuant to Article 9(2)(a) of the GDPR. Consent is given voluntarily prior to the treatment and can be withdrawn at any time, without affecting the lawfulness of processing based on consent before its withdrawal. These data cannot and must not be processed under legitimate interest.',
          },
        ],
      },
      {
        title: '4. Video Surveillance System',
        blocks: [
          {
            type: 'paragraph',
            text: 'Cora Hotel operates a video surveillance system to protect individuals, properties, and prevent unlawful activities on hotel premises. This constitutes our legitimate interest under Article 6(1)(f) of the GDPR and Articles 25-31 of the Croatian Law on the Implementation of the General Data Protection Regulation.',
          },
          {
            type: 'list',
            items: [
              {
                text: 'Retention Period: Video recordings are stored for a maximum of 30 days from the date of recording, after which they are automatically overwritten/deleted, unless required in a specific case as evidence in legal, police, or court proceedings.',
              },
              {
                text: 'Data Subject Rights: Data subjects have the right to request access to video footage if they are captured on it, provided it does not infringe upon the privacy rights of third parties.',
              },
            ],
          },
        ],
      },
      {
        title: '5. Legal Bases for Data Processing',
        blocks: [
          {
            type: 'paragraph',
            text: 'All categories of your personal data are processed strictly based on the following legal grounds under the GDPR:',
          },
          {
            type: 'list',
            items: [
              {
                text: 'a) Compliance with Legal Obligations (Art. 6.1.c): Processing is necessary to comply with the legal regulations of the Republic of Croatia (hospitality, tax, accounting laws, and eVisitor registration).',
              },
              {
                text: 'b) Performance of a Contract (Art. 6.1.b): Processing is necessary for the realization of accommodation bookings, provision of services, or performance of business cooperation agreements.',
              },
              {
                text: 'c) Explicit Consent (Art. 6.1.a / Art. 9.2.a): For newsletter distribution, marketing activities, or the processing of health data within the wellness center.',
              },
              {
                text: 'd) Legitimate Interest (Art. 6.1.f): For the operations of the video surveillance system (security) and securing subsequent payments of undeclared services via credit card.',
              },
            ],
          },
        ],
      },
      {
        title: '6. Data Retention Periods',
        blocks: [
          {
            type: 'paragraph',
            text: 'In line with the storage limitation principle under Article 5(1)(e) of the GDPR, we have set concrete and transparent data retention periods:',
          },
          {
            type: 'list',
            items: [
              {
                text: 'Billing Data and Financial Transactions: Retained for 11 years pursuant to the Croatian Accounting Act.',
              },
              {
                text: 'Guest Book and eVisitor Registration Data: Retained permanently pursuant to the Croatian Hospitality Services Act.',
              },
              {
                text: 'Contact Forms and E-mail Inquiries: Deleted after the complete resolution of your request, and at the latest within 6 months, unless a booking is successfully completed.',
              },
              {
                text: 'Video Surveillance Footage: Overwritten and automatically deleted after a maximum of 30 days.',
              },
            ],
          },
        ],
      },
      {
        title: '7. Data Subject Rights',
        blocks: [
          {
            type: 'paragraph',
            text: 'As a data subject, you hold the following rights which can be exercised at any time by sending a request to voditelj.obrade@manas.hr:',
          },
          {
            type: 'list',
            items: [
              {
                text: 'a) Right of Access: The right to obtain confirmation of processing, details about the processing, and to receive a copy of all your processed personal data.',
              },
              {
                text: 'b) Right to Rectification: The right to obtain without undue delay the rectification or completion of inaccurate or incomplete personal data.',
              },
              {
                text: 'c) Right to Erasure ("Right to be Forgotten"): The right to obtain data erasure if it is no longer needed for the processing purpose, or if consent is withdrawn, unless legal retention laws state otherwise.',
              },
              {
                text: 'd) Right to Restriction of Processing: Applicable when you contest data accuracy or when the processing is unlawful but you oppose erasure.',
              },
              {
                text: 'e) Right to Object: The right to object to processing based on legitimate interest.',
              },
              {
                text: 'f) Right to Data Portability: The right to receive your data in a structured, commonly used, and machine-readable format.',
              },
              {
                text: 'g) Right to Lodge a Complaint with a Supervisory Authority: You have the right to file a complaint directly with the Croatian national supervisory body:',
                details: [
                  'Croatian Personal Data Protection Agency (AZOP)',
                  'Sironićeva 15, 10000 Zagreb, Croatia',
                  'Web: www.azop.hr | E-mail: azop@azop.hr | Tel: +385 (0)1 4609 000',
                ],
              },
            ],
          },
        ],
      },
      {
        title:
          '8. Connected External Booking Platforms and Third-Party Transfers',
        blocks: [
          {
            type: 'paragraph',
            text: 'When making online reservations for accommodation we utilize integrated external platform: Directbook (for accommodation booking). The platform act as data processors on our behalf. Your personal data (name, contact details, card information) is transferred to these platforms solely for the purpose of executing and confirming your booking, pursuant to signed Data Processing Agreements (DPA) under Article 28 of the GDPR. Data may also be forwarded to competent state authorities (Ministry of the Interior, Tax Administration) strictly based on statutory legal obligations.',
          },
        ],
      },
    ],
  },
  footer: {
    smsInvoice: 'SMS Parking invoice',
  },
  evPaymentRedirect: {
    chargerLabel: 'Punionica / EV charger',
    redirectingTitle: 'Preusmjeravanje na placanje / Redirecting to payment',
    unavailableTitle:
      'Placanje trenutno nije dostupno / Payment is currently unavailable',
    loadingMessage:
      'Molimo pricekajte dok otvaramo stranicu za placanje. / Please wait while we open the payment page.',
    contactReception:
      'Molimo obratite se recepciji za pomoc. / Please contact reception for assistance.',
    configError:
      'Konfiguracija placanja nije dostupna. / Payment configuration could not be loaded.',
    homeLink: 'Cora Hotel',
  },
};
